/* /rules/builder — kept for deep-link backwards compatibility.
 * Mounts the unified RulesHub on the Builder tab; `?from=<rule-id>`
 * is read by BuilderTab via useSearchParams. */

import { RulesHub } from "../components/rules/RulesHub";

export default function RuleBuilderPage(): JSX.Element {
  return <RulesHub initialTab="builder" />;
}
